import * as constants from './actions';

const initialState = {
    activeCarouselActionIndex: 0
};

export default function actionChoiceCard(state = initialState, { type, payload }) {
    switch (type) {
        case constants.ACTION_CHOICE_BEGIN_ACTION:
            return {
                ...state
            };
        case constants.ACTION_CHOICE_CLEAR_ACTION:
            return {
                ...state,
                activeCarouselActionIndex: 0
            };
        case constants.ACTION_CHOICE_CAROUSEL_FORWARD:
            return {
                ...state,
                activeCarouselActionIndex: state.activeCarouselActionIndex + 1
            };
        case constants.ACTION_CHOICE_CAROUSEL_BACK:
            return {
                ...state,
                activeCarouselActionIndex: state.activeCarouselActionIndex - 1
            };
        case constants.ACTION_CHOICE_SET_ACTIVE_ACTION_FROM_SWIPE:
            return {
                ...state,
                activeCarouselActionIndex: payload
            };
        case constants.SET_CHOICE_PARTNER:
          return {
              ...state,
              partner: payload
          }
        default:
            return state;
    }
}
